// extracted by mini-css-extract-plugin
export var infoMessage = "info-message_jyIoIBdiHQ7zoXAiE5tl";